export default {
  INVALID_SESSION: 0,
  SUCCESS: 1,
  SERVER_ERROR: 2,
  NOT_ALLOWED: 3
};
